import { axios } from "./http.js";

export const addBrand = params => {
  return axios.post("/brand_trend/", params);
};
// 查询指定分类下的资讯列表;
export const getBrandList = params =>
  axios.get(
    `/brand_trend/list/${params.category}/${params.pageNo}/${params.pageSize}`
  );

export const deleteBrand = id => {
  return axios.delete(`/brand_trend/${id}`);
};

export const putBrand = params => {
  return axios.put(`/brand_trend/${params.id}`, params);
};
export const getBrand = id => axios.get(`/brand_trend/${id}`);
